import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren, QueryList, OnChanges, ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FileDocument, StatusDoc } from '../models/file-document.model';
import { AuthService } from '../auth/auth.service';
import { MessageAtributtes, MessageType } from '../models/message-types.model';
import { GenericBottomSheetComponent } from '../generic-bottom-sheet/generic-bottom-sheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { FileDocumentService } from '../services/file-document.service';
import { DocumentationTypesService } from "../../shared/services/documentation-types.service";
import { MessageService } from '../errorHandler/message.service';
import { FileDocumentMetadataComponent } from '../file-document-metadata/file-document-metadata.component';
import { DocumentationType } from '../models/documentation-type.model';
import { DocumentationService } from '../services/documentation.service';
import { FormioCardinalComponent } from '../../formioCs/formio-cardinal.component';
import { DocumentationTypeSetService } from "../../shared/services/documentation-type-set.service";
import { firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { FileProveDocumentViewModalComponent } from '../file-prove-document-view-modal/file-prove-document-view-modal.component';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  standalone: false,
  selector: 'app-file-document-detail',
  templateUrl: './file-document-detail.component.html',
  styles: []
})
export class FileDocumentDetailComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChildren(FormioCardinalComponent) formioCardinal: QueryList<FormioCardinalComponent>;

  @Input() filePdf = "";
  @Input() fileBlob: Blob;
  @Input() doc: FileDocument;
  @Input() documentationType: DocumentationType;
  @Input() isZip = false;
  @Input() fileName = "";
  @Input() setId = null;

  // Habilitan o deshabilitan cosas visuales
  @Input() showFileDocumentHeader = true;
  @Input() showCancel = false;
  @Input() showWelcome = false;
  @Input() showPrint = true;
  @Input() showSave = true;
  @Input() showZoomIn = true;
  @Input() showZoomOut = true;
  @Input() showRemove = false;
  @Input() showDelete = true;
  @Input() showAll = true;
  @Input() showMetadatas = true;
  @Input() floatingMode: false;
  @Input() showQuery = false;
  @Input() showNom151 = false;

  // Outputs
  @Output() finishCancelEvent = new EventEmitter<boolean>();
  @Output() submitFormioEvent = new EventEmitter<boolean>();
  @Output() mobileCloseEvent = new EventEmitter<boolean>();
  @Output() goBackEvent = new EventEmitter<boolean>();

  @Output() closedQuery = new EventEmitter<boolean>();


  canCancel: boolean;
  canDelete: boolean;
  showSpinner = false;
  showFormio = false;
  saving = false;
  allowsFormio = false;
  showChapa = false;
  canceledChapa = false;
  accion: (...args: unknown[]) => unknown;
  autoSizeDoc = false;
  isQueryActive = false;

  private readonly destroyRef = inject(DestroyRef);
  constructor(private authService: AuthService,
    private _bottomSheet: MatBottomSheet,
    private fileDocumentService: FileDocumentService,
    private msjService: MessageService,
    private documentationService: DocumentationService,
    private documentationTypesService: DocumentationTypesService,
    private documentationTypeSetService: DocumentationTypeSetService,
    private ref: ChangeDetectorRef,
    private readonly dialog: MatDialog,
    private readonly transloco: TranslocoService
  ) { }

  verEvidenciasdeFirmas(item: FileDocument) {
    let collaboration = [];
    this.fileDocumentService.getCollaboration(item.id, item.organizationalUnitId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(coll => {
        collaboration = coll;
        const signature = item.documentFileSignaturesData?.[0];
        const sourceDocument = signature?.proveDocumentId
          ? Promise.resolve(item)
          : firstValueFrom(this.fileDocumentService.getDocumentDetail(item.id));

        sourceDocument.then(source => {
          const signatures = source.documentFileSignaturesData ?? [];
          const proveDocumentId = signature?.proveDocumentId ?? signatures[0]?.proveDocumentId;
          if (!proveDocumentId) {
            throw new Error(this.transloco.translate('fileDocuments.fileDocumentDetail.nom151EvidenceNotFoundMsg'));
          }

          return firstValueFrom(this.fileDocumentService.getDocumentDetail(proveDocumentId))
            .then(res => ({ res, signatures }));
        }).then(({ res, signatures }) => {
          res.employeeCollaborationData = item.employeeCollaborationData;
          res.lawyerCollaborationData = item.lawyerCollaborationData;
          res.documentFileSignaturesData = signatures;
          res.collaboration = collaboration;
          res.documentDate = new Date(signatures[0].signedDate);
          this.dialog.open(FileProveDocumentViewModalComponent, { data: res });
        }).catch(error => {
          this.msjService.showError(error);
        });
      });
  }

  ngOnInit() {
    this.resetValues();
  }

  ngOnChanges() {
    this.resetValues();
    if(this.doc != null && this.doc.employeeLegalId != null && this.doc.nroLegajo == null){
      firstValueFrom(this.documentationTypeSetService.getSetbyIdFiscal(this.doc.employeeLegalId,this.doc.organizationalUnitId)).then(
        data => {
          this.setId = data?.setId ?? 0
        },
        err => this.msjService.showError(err)
      );
    }
  }

  public ngAfterViewInit(): void {
    this.formioCardinal.changes.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((comps: QueryList<FormioCardinalComponent>) => {
      this.accion = function () { this.saving = true; comps.first.submitForm(); };
    });
  }

  ShowPdf(): boolean {
    return this.filePdf != "" || this.fileBlob != null;
  }

  mobileClose() {
    this.mobileCloseEvent.emit(true);
  }

  showMetadatos() {
    this._bottomSheet.open(FileDocumentMetadataComponent, {
      hasBackdrop: true,
      data: {
        doc: this.doc,
        showOtrosMetadatos: true
      },
    });
  }

  cancelFileDocument() {
    const parameters: MessageAtributtes = {
      bodyText: this.transloco.translate('fileDocuments.fileDocumentDetail.rejectDocumentTitle'),
      infoText: this.transloco.translate('fileDocuments.fileDocumentDetail.rejectDocumentInfo'),
      inputLabel: this.transloco.translate('fileDocuments.fileDocumentDetail.rejectReasonLbl'),
      inputHint: this.transloco.translate('fileDocuments.fileDocumentDetail.rejectReasonHint'),
      type: MessageType.TextAreaYesNo
    };

    const t = this._bottomSheet.open(GenericBottomSheetComponent, { data: parameters, disableClose: true });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t.instance.closed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((buttonSheetResponse: any) => {
      if (buttonSheetResponse.response) {
        this.showSpinner = true;
        firstValueFrom(this.fileDocumentService.cancel(+this.doc.id,buttonSheetResponse.text,this.setId ?? 0))
          .then(_r => {
            this.msjService.showInfo(this.transloco.translate('common.documentRejectedLbl'));
            this.showSpinner = false;
            this.doc.statusId = StatusDoc.Canceled;
            this.doc.rejectedMotive = buttonSheetResponse.text;
            this.doc.rejectedDate = new Date();
            this.finishCancelEvent.emit(true);
          })
          .catch(e => {
            this.msjService.showError(e);
            this.showSpinner = false;
          });
      }
    });
  }

  deleteFileDocument() {
    const parameters: MessageAtributtes = {
      bodyText: this.transloco.translate('documentsToSign.warningDeleteDocumentLbl'),
      infoText: this.transloco.translate('documentsToSign.warningDeleteDocumentSubtitleLbl'),
      type: MessageType.CaptchaNumbers
    };

    const t = this._bottomSheet.open(GenericBottomSheetComponent, { data: parameters, disableClose: true });
    t.instance.closed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: boolean) => {
      if (response) {
        this.showSpinner = true;
        // firstValueFrom(this.fileDocumentService.delete(+this.doc.id))
        firstValueFrom(this.fileDocumentService.inactive(+this.doc.id, this.setId ?? 0))
          .then(_r => {
            this.msjService.showInfo(this.transloco.translate('fileDocuments.fileDocumentDetail.deleteSuccessMsg'));
            this.filePdf = '';
            this.fileBlob = null;
            this.doc = null;
            this.resetValues();
            this.showSpinner = false;
            this.finishCancelEvent.emit(true);
          })
          .catch(e => {
            this.msjService.showError(e);
            this.showSpinner = false;
          });
      }
    });
  }

  removeFile() {
    this.filePdf = null;
  }

  submitFormio(submission) {
    if (!submission) {
      setTimeout(() => {
        this.saving = false;
        this.ref.detectChanges();
      }, 2000);
      return;
    }

    this.saving = true;
    this.doc.formioFormAlias = this.documentationType.exteralForm;
    this.doc.formioSubmissionId = submission._id;
    this.doc.documentationTypeSelected = this.documentationType;

    firstValueFrom(this.documentationService.employeeUpload(this.doc, null))
      .then(() => {
        this.submitFormioEvent.emit(true);
        this.saving = false;
      })
      .catch(err => {
        this.msjService.showError(err);
        this.saving = false;
      });
  }

  private resetValues() {
    if (!this.doc) {
      this.showWelcome = true;
      this.showSpinner = false;
    } else {
      this.canDelete = this.authService.RRHHManagment() || this.authService.isGestorDocumental() || this.authService.isCandidateAdmin() || this.authService.isCandidateAdminBasic();
      this.canCancel = this.authService.isRRHH() || this.authService.isCandidateAdmin() || this.authService.isGestorDocumental() || this.authService.isCandidateAdminBasic();
      this.showWelcome = false;
      this.showSpinner = false;
      this.allowsFormio = this.documentationType && this.documentationType.exteralForm != null && this.documentationType.documentationLoadContentName == 'EMPLEADO';
      this.canceledChapa = this.doc.isCanceled();
    }
    this.showChapa = !this.ShowPdf() && (this.showWelcome || this.doc?.isUploadPending() || this.doc?.isCanceled());
    this.showFormio = false;
    this.saving = false;
  }
  goBack() {
    this.goBackEvent.emit(true);
  }
  hideChapa() {
    this.canceledChapa = false;
    this.autoSizeDoc = !this.autoSizeDoc
  }


}
